import React, { useState, useEffect } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Table, CardBody, Card } from "reactstrap";
import { Spinner } from "reactstrap";
import { apiClient } from '../../helpers/api_helper';
import { formatNumber } from "../../helpers/format_helper";



const Channels = () => {
    const [menu1, setMenu1] = useState<boolean>(false);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

   
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await apiClient.get("/analytics/valor-por-financiador/");                
                setData(response.data ? response.data : response);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []); // Empty dependency array means this effect runs once on mount

    if (loading) {
        return <Spinner color="primary" />;
    }

    return (
        <React.Fragment>
            <Card className="card-h-100">
                <CardBody>
                    <div className="d-flex align-items-start">
                        <div className="flex-grow-1 overflow-hidden">
                            <h5 className="card-title text-truncate mb-3">Valores por Financiador</h5>
                        </div>

                        <div className="flex-shrink-0">
                            <Dropdown
                                isOpen={menu1}
                                toggle={() => setMenu1(!menu1)}
                            >
                                <DropdownToggle tag="a" className="text-reset">
                                    <span className="fw-semibold">Report By:</span> <span className="text-muted">Monthly<i className="mdi mdi-chevron-down ms-1"></i></span>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-end">
                                    <DropdownItem to="#">Yearly</DropdownItem>
                                    <DropdownItem to="#">Monthly</DropdownItem>
                                    <DropdownItem to="#">Weekly</DropdownItem>
                                    <DropdownItem to="#">Today</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>

                        </div>
                    </div>
                    <div className="table-responsive">
                        <Table className="mb-0" striped={true} size="sm">
                            <thead>
                                <tr>
                                    <th scope="col">Financiador</th>
                                    <th scope="col" className="text-end">Valor</th>
                                    <th scope="col">Moeda</th>
                                    {/*<th scope="col" style={{ width: "25%" }}>Bounce Rate</th>*/}
                                </tr>
                            </thead>
                            <tbody>
                                {(data || []).map((financiador: any) => (
                                    <tr key={financiador["financiador"]}>
                                        <th scope="row">{financiador["financiador"]}</th>
                                        <td className="text-end">{formatNumber(financiador["valor"])}</td>
                                        <td>{financiador["moeda"]}</td>
                                        {/*<td><div className="text-success text-nowrap">{financiador["bouncerate"]}%</div></td>*/}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default Channels;